import { render, staticRenderFns } from "./live-ing.vue?vue&type=template&id=545cbc38&scoped=true"
import script from "./live-ing.vue?vue&type=script&lang=js"
export * from "./live-ing.vue?vue&type=script&lang=js"
import style0 from "./live-ing.vue?vue&type=style&index=0&id=545cbc38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cbc38",
  null
  
)

export default component.exports